import React, { useMemo } from 'react';
import copy from '../../data/homeCopy/en.json';
import HomePage from './HomePage';
import { useAskExamples } from './useAskExamples';

const EXAMPLE_QUESTIONS = [
  'Will I find love this year?',
  'Should I take the job?',
  'Is he the one?',
  'What do I need to hear?',
];

const TITLE = 'NowTarot: Free AI Tarot Reading, Instant Answers';

const HEAD = [
  <title key="title">{TITLE}</title>,
  <meta key="description" name="description" content="Ask the AI tarot anything and get a free, personalized tarot reading in seconds. Yes or no, love, career, and more. No sign-up, no credit card, available 24/7." />,
  <meta key="keywords" name="keywords" content="ai tarot, tarot ai, ai tarot reading, free ai tarot reading, free online tarot reading, yes or no tarot, love tarot, 3 card tarot" />,
  <link key="canonical" rel="canonical" href="https://nowtarot.com/" />,
  <meta key="og:title" property="og:title" content={TITLE} />,
  <meta key="og:description" property="og:description" content="Ask the AI tarot anything and get your free reading in seconds. No sign-up required." />,
  <meta key="og:site_name" property="og:site_name" content="NowTarot AI" />,
  <meta key="og:image" property="og:image" content="https://nowtarot.com/og-image.png" />,
  <meta key="og:url" property="og:url" content="https://nowtarot.com/" />,
  <meta key="og:type" property="og:type" content="website" />,
  <meta key="twitter:card" name="twitter:card" content="summary_large_image" />,
  <meta key="twitter:title" name="twitter:title" content={TITLE} />,
  <meta key="twitter:description" name="twitter:description" content="Ask the AI tarot anything and get your free reading in seconds, 24/7." />,
  <meta key="twitter:image" name="twitter:image" content="https://nowtarot.com/og-image.png" />,
];

const JSON_LD = [
  {
    "@type": "WebSite",
    "name": "NowTarot AI",
    "alternateName": "NowTarot",
    "url": "https://nowtarot.com"
  },
  {
    "@type": "Service",
    "name": "NowTarot AI",
    "description": "Free AI tarot readings with instant answers. Ask any question and get your cards interpreted in seconds, 24/7.",
    "url": "https://nowtarot.com",
    "provider": {
      "@type": "Organization",
      "name": "NowTarot AI",
      "url": "https://nowtarot.com"
    },
    "serviceType": "AI Tarot Reading",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "description": "Free instant AI tarot readings"
    }
  },
];

const Landing = () => {
  const examples = useAskExamples('en', EXAMPLE_QUESTIONS);
  const ask = useMemo(() => ({ examples }), [examples]);

  return <HomePage copy={copy} head={HEAD} jsonLd={JSON_LD} ask={ask} />;
};

export default Landing;
